/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './calculation-editor.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i3 from '@angular/material';
import * as i4 from '@angular/cdk/platform';
import * as i5 from '@angular/forms';
import * as i6 from '@angular/cdk/scrolling';
import * as i7 from '@angular/cdk/overlay';
import * as i8 from '@angular/cdk/bidi';
import * as i9 from '@angular/common';
import * as i10 from '../../../fields/components/field/field.component.ngfactory';
import * as i11 from '../../../../../../app/modules/fields/components/field/field.component';
import * as i12 from '../../../../../../app/modules/fields/services/field-form/field-form.service';
import * as i13 from '../../../utilities/components/small-spinner/small-spinner.component.ngfactory';
import * as i14 from '../../../../../../app/modules/utilities/components/small-spinner/small-spinner.component';
import * as i15 from '../../../../../../app/modules/form-builder/components/calculation-editor/calculation-editor.component';
import * as i16 from '../../../../../../app/modules/form-builder/services/calculation/calculation.service';
import * as i17 from '../../../../../../app/modules/form-builder/services/field-group/field-group.service';
const styles_CalculationEditorComponent:any[] = [i0.styles];
export const RenderType_CalculationEditorComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_CalculationEditorComponent,data:{}});
function View_CalculationEditorComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'md-option',
      [['class','mat-option'],['role','option']],[[1,'tabindex',0],[2,'mat-selected',
          (null as any)],[2,'mat-option-multiple',(null as any)],[2,'mat-active',(null as any)],
          [8,'id',0],[1,'aria-selected',0],[1,'aria-disabled',0],[2,'mat-option-disabled',
              (null as any)]],[[(null as any),'click'],[(null as any),'keydown']],
      (_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1)._selectViaInteraction()) !== false);
          ad = (pd_0 && ad);
        }
        if (('keydown' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,1)._handleKeydown($event)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i2.View_MdOption_0,i2.RenderType_MdOption)),i1.ɵdid(1,49152,[[1,4]],0,i3.MdOption,
      [i1.ElementRef,i1.ChangeDetectorRef,[2,i3.MdOptgroup],[2,i3.MATERIAL_COMPATIBILITY_MODE]],
      {value:[0,'value']},(null as any)),i1.ɵdid(2,16384,(null as any),0,i3.MdPrefixRejector,
      [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      (_l()(),i1.ɵted(3,0,['','']))],(_ck,_v) => {
    const currVal_8:any = _v.context.$implicit;
    _ck(_v,1,0,currVal_8);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1)._getTabIndex();
    const currVal_1:any = i1.ɵnov(_v,1).selected;
    const currVal_2:any = i1.ɵnov(_v,1).multiple;
    const currVal_3:any = i1.ɵnov(_v,1).active;
    const currVal_4:any = i1.ɵnov(_v,1).id;
    const currVal_5:any = i1.ɵnov(_v,1).selected.toString();
    const currVal_6:any = i1.ɵnov(_v,1).disabled.toString();
    const currVal_7:any = i1.ɵnov(_v,1).disabled;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7);
    const currVal_9:any = _v.context.$implicit;
    _ck(_v,3,0,currVal_9);
  });
}
function View_CalculationEditorComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),35,'div',[['class',
      'field']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(2,0,(null as any),
          (null as any),9,'button',[['class','field-column mat-mini-fab'],['color',
              'warn'],['md-mini-fab',''],['type','button']],[[8,'disabled',0]],[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.removeField(_v.context.$implicit)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(3,16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(4,180224,(null as any),0,i3.MdButton,
          [i1.Renderer2,i1.ElementRef,i4.Platform,i3.FocusOriginMonitor],{color:[0,
              'color']},(null as any)),i1.ɵdid(5,16384,(null as any),0,i3.MdMiniFab,
          [[2,i3.MdButton],[8,(null as any)]],(null as any),(null as any)),(_l()(),
          i1.ɵted(-1,0,['\n    '])),(_l()(),i1.ɵeld(7,0,(null as any),0,3,'md-icon',
          [['class','mat-icon'],['role','img']],(null as any),(null as any),(null as any),
          i2.View_MdIcon_0,i2.RenderType_MdIcon)),i1.ɵdid(8,16384,(null as any),0,
          i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
          (null as any)),i1.ɵdid(9,638976,(null as any),0,i3.MdIcon,[i1.Renderer2,
          i1.ElementRef,i3.MdIconRegistry,[8,(null as any)]],(null as any),(null as any)),
      (_l()(),i1.ɵted(-1,0,['remove'])),(_l()(),i1.ɵted(-1,0,['\n  '])),(_l()(),i1.ɵted(-1,
          (null as any),['\n  '])),(_l()(),i1.ɵeld(13,0,(null as any),(null as any),
          12,'md-select',[['class','field-column mat-select'],['placeholder','Pick a letter'],
              ['role','listbox']],[[1,'tabindex',0],[1,'aria-label',0],[1,'aria-labelledby',
              0],[1,'aria-required',0],[1,'aria-disabled',0],[1,'aria-invalid',0],
              [1,'aria-owns',0],[1,'aria-multiselectable',0],[2,'mat-select-disabled',
                  (null as any)],[2,'mat-select-invalid',(null as any)],[2,'mat-select-required',
                  (null as any)],[2,'ng-untouched',(null as any)],[2,'ng-touched',
                  (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
              [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
                  (null as any)]],[[(null as any),'valueChange'],[(null as any),'ngModelChange'],
              [(null as any),'keydown'],[(null as any),'blur']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('keydown' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,17)._handleClosedKeydown($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,17)._onBlur()) !== false);
              ad = (pd_1 && ad);
            }
            if (('valueChange' === en)) {
              const pd_2:any = ((<any>_co.optionSelected(_co.lettersModel[_v.context.index],
                  _v.context.index)) !== false);
              ad = (pd_2 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_3:any = ((<any>(_co.lettersModel[_v.context.index] = $event)) !== false);
              ad = (pd_3 && ad);
            }
            return ad;
          },i2.View_MdSelect_0,i2.RenderType_MdSelect)),i1.ɵdid(14,16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(15,671744,(null as any),0,i5.NgModel,
          [[8,(null as any)],[8,(null as any)],[8,(null as any)],[8,(null as any)]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i5.NgControl,(null as any),[i5.NgModel]),i1.ɵdid(17,1294336,(null as any),
          3,i3.MdSelect,[i6.ViewportRuler,i1.ChangeDetectorRef,i7.Overlay,i4.Platform,
              i1.Renderer2,i1.ElementRef,[2,i8.Directionality],[2,i5.NgForm],[2,i5.FormGroupDirective],
              [2,i5.NgControl],[8,(null as any)],[2,i3.MD_PLACEHOLDER_GLOBAL_OPTIONS],
              i3.MD_SELECT_SCROLL_STRATEGY],{placeholder:[0,'placeholder']},{valueChange:'valueChange'}),
      i1.ɵqud(603979776,1,{options:1}),i1.ɵqud(603979776,2,{optionGroups:1}),i1.ɵqud(335544320,
          3,{customTrigger:0}),i1.ɵdid(21,16384,(null as any),0,i5.NgControlStatus,
          [i5.NgControl],(null as any),(null as any)),(_l()(),i1.ɵted(-1,1,['\n    '])),
      (_l()(),i1.ɵand(16777216,(null as any),1,1,(null as any),View_CalculationEditorComponent_2)),
      i1.ɵdid(24,802816,(null as any),0,i9.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,
          1,['\n  '])),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(27,
          0,(null as any),(null as any),1,'app-field',[['class','field-column']],[[2,
              'not-required',(null as any)]],[[(null as any),'edited']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('edited' === en)) {
              const pd_0:any = ((<any>_co.onValueChanged($event,_v.context.$implicit.field)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i10.View_FieldComponent_0,i10.RenderType_FieldComponent)),i1.ɵdid(28,114688,
          (null as any),0,i11.FieldComponent,[i1.ComponentFactoryResolver,i12.FieldFormService],
          {form:[0,'form'],fieldValue:[1,'fieldValue']},{edited:'edited'}),(_l()(),
          i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(30,0,(null as any),(null as any),
          4,'button',[['class','field-column mat-raised-button'],['md-raised-button',
              ''],['type','button']],[[8,'disabled',0]],[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.replaceCalculationInputField(_v.context.$implicit)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(31,16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(32,180224,(null as any),0,i3.MdButton,
          [i1.Renderer2,i1.ElementRef,i4.Platform,i3.FocusOriginMonitor],(null as any),
          (null as any)),i1.ɵdid(33,16384,(null as any),0,i3.MdRaisedButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(34,0,['',''])),
      (_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = 'warn';
    _ck(_v,4,0,currVal_1);
    _ck(_v,9,0);
    const currVal_20:any = _co.lettersModel[_v.context.index];
    _ck(_v,15,0,currVal_20);
    const currVal_21:any = 'Pick a letter';
    _ck(_v,17,0,currVal_21);
    const currVal_22:any = _co.lettersArray;
    _ck(_v,24,0,currVal_22);
    const currVal_24:any = _co.calculationFormGroup;
    const currVal_25:any = _co.getFieldValueFromField(_v.context.$implicit.field);
    _ck(_v,28,0,currVal_24,currVal_25);
  },(_ck,_v) => {
    const currVal_0:any = (i1.ɵnov(_v,4).disabled || (null as any));
    _ck(_v,2,0,currVal_0);
    const currVal_2:any = i1.ɵnov(_v,17).tabIndex;
    const currVal_3:any = i1.ɵnov(_v,17)._ariaLabel;
    const currVal_4:any = i1.ɵnov(_v,17).ariaLabelledby;
    const currVal_5:any = i1.ɵnov(_v,17).required.toString();
    const currVal_6:any = i1.ɵnov(_v,17).disabled.toString();
    const currVal_7:any = i1.ɵnov(_v,17)._isErrorState();
    const currVal_8:any = i1.ɵnov(_v,17)._optionIds;
    const currVal_9:any = i1.ɵnov(_v,17).multiple;
    const currVal_10:any = i1.ɵnov(_v,17).disabled;
    const currVal_11:any = i1.ɵnov(_v,17)._isErrorState();
    const currVal_12:any = i1.ɵnov(_v,17).required;
    const currVal_13:any = i1.ɵnov(_v,21).ngClassUntouched;
    const currVal_14:any = i1.ɵnov(_v,21).ngClassTouched;
    const currVal_15:any = i1.ɵnov(_v,21).ngClassPristine;
    const currVal_16:any = i1.ɵnov(_v,21).ngClassDirty;
    const currVal_17:any = i1.ɵnov(_v,21).ngClassValid;
    const currVal_18:any = i1.ɵnov(_v,21).ngClassInvalid;
    const currVal_19:any = i1.ɵnov(_v,21).ngClassPending;
    _ck(_v,13,1,[currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,
        currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,currVal_14,currVal_15,
        currVal_16,currVal_17,currVal_18,currVal_19]);
    const currVal_23:any = i1.ɵnov(_v,28).isNotRequired;
    _ck(_v,27,0,currVal_23);
    const currVal_26:any = (i1.ɵnov(_v,32).disabled || (null as any));
    _ck(_v,30,0,currVal_26);
    const currVal_27:any = _v.context.$implicit.field.name;
    _ck(_v,34,0,currVal_27);
  });
}
function View_CalculationEditorComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-small-spinner',
      ([] as any[]),(null as any),(null as any),(null as any),i13.View_SmallSpinnerComponent_0,
      i13.RenderType_SmallSpinnerComponent)),i1.ɵdid(1,114688,(null as any),0,i14.SmallSpinnerComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
function View_CalculationEditorComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'md-icon',[['class',
      'mat-icon'],['color','warn'],['role','img']],(null as any),(null as any),(null as any),
      i2.View_MdIcon_0,i2.RenderType_MdIcon)),i1.ɵdid(1,16384,(null as any),0,i3.MdPrefixRejector,
      [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(2,638976,(null as any),0,i3.MdIcon,[i1.Renderer2,i1.ElementRef,i3.MdIconRegistry,
          [8,(null as any)]],{color:[0,'color']},(null as any)),(_l()(),i1.ɵted(-1,
          0,['close']))],(_ck,_v) => {
    const currVal_0:any = 'warn';
    _ck(_v,2,0,currVal_0);
  },(null as any));
}
function View_CalculationEditorComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'md-icon',[['class',
      'mat-icon'],['color','accent'],['role','img']],(null as any),(null as any),(null as any),
      i2.View_MdIcon_0,i2.RenderType_MdIcon)),i1.ɵdid(1,16384,(null as any),0,i3.MdPrefixRejector,
      [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(2,638976,(null as any),0,i3.MdIcon,[i1.Renderer2,i1.ElementRef,i3.MdIconRegistry,
          [8,(null as any)]],{color:[0,'color']},(null as any)),(_l()(),i1.ɵted(-1,
          0,['check']))],(_ck,_v) => {
    const currVal_0:any = 'accent';
    _ck(_v,2,0,currVal_0);
  },(null as any));
}
export function View_CalculationEditorComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵeld(1,0,
      (null as any),(null as any),12,'div',[['class','add-container']],(null as any),
      (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
      (null as any),['\n  '])),(_l()(),i1.ɵeld(3,0,(null as any),(null as any),9,'button',
      [['class','addButton mat-mini-fab'],['md-mini-fab','']],[[8,'disabled',0]],[[(null as any),
          'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i15.CalculationEditorComponent = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.addCalculationInputField()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(4,16384,(null as any),
      0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
      (null as any)),i1.ɵdid(5,180224,(null as any),0,i3.MdButton,[i1.Renderer2,i1.ElementRef,
      i4.Platform,i3.FocusOriginMonitor],(null as any),(null as any)),i1.ɵdid(6,16384,
      (null as any),0,i3.MdMiniFab,[[2,i3.MdButton],[8,(null as any)]],(null as any),
      (null as any)),(_l()(),i1.ɵted(-1,0,['\n    '])),(_l()(),i1.ɵeld(8,0,(null as any),
      0,3,'md-icon',[['class','mat-icon'],['role','img']],(null as any),(null as any),
      (null as any),i2.View_MdIcon_0,i2.RenderType_MdIcon)),i1.ɵdid(9,16384,(null as any),
      0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
      (null as any)),i1.ɵdid(10,638976,(null as any),0,i3.MdIcon,[i1.Renderer2,i1.ElementRef,
      i3.MdIconRegistry,[8,(null as any)]],(null as any),(null as any)),(_l()(),i1.ɵted(-1,
      0,['add'])),(_l()(),i1.ɵted(-1,0,['\n  '])),(_l()(),i1.ɵted(-1,(null as any),
      ['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n\n'])),(_l()(),i1.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_CalculationEditorComponent_1)),
      i1.ɵdid(16,802816,(null as any),0,i9.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,
          (null as any),['\n\n\n\n'])),(_l()(),i1.ɵeld(18,0,(null as any),(null as any),
          73,'div',[['class','formula-container']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(21,0,(null as any),
          (null as any),27,'md-input-container',[['class','with-cursor-position mat-input-container mat-form-field']],
          [[2,'mat-input-invalid',(null as any)],[2,'mat-form-field-invalid',(null as any)],
              [2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],[2,
                  'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,23)._control.focus()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdFormField_0,i2.RenderType_MdFormField)),i1.ɵdid(22,16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(23,7389184,(null as any),6,i3.MdFormField,
          [i1.ElementRef,i1.ChangeDetectorRef,[2,i3.MD_PLACEHOLDER_GLOBAL_OPTIONS]],
          (null as any),(null as any)),i1.ɵqud(335544320,4,{_control:0}),i1.ɵqud(335544320,
          5,{_placeholderChild:0}),i1.ɵqud(603979776,6,{_errorChildren:1}),i1.ɵqud(603979776,
          7,{_hintChildren:1}),i1.ɵqud(603979776,8,{_prefixChildren:1}),i1.ɵqud(603979776,
          9,{_suffixChildren:1}),(_l()(),i1.ɵted(-1,1,['\n    '])),(_l()(),i1.ɵeld(31,
          0,(null as any),1,1,'label',([] as any[]),(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['Formula'])),
      (_l()(),i1.ɵted(-1,1,['\n    '])),(_l()(),i1.ɵeld(34,0,[['inputBox',1]],1,8,
          'input',[['class','mat-input-element'],['mdInput','']],[[8,'id',0],[8,'placeholder',
              0],[8,'disabled',0],[8,'required',0],[1,'aria-describedby',0],[1,'aria-invalid',
              0],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,
              'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
              (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'ngModelChange'],[(null as any),'click'],[(null as any),
              'keyup'],[(null as any),'input'],[(null as any),'blur'],[(null as any),
              'compositionstart'],[(null as any),'compositionend'],[(null as any),
              'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i15.CalculationEditorComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,36)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,36).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,36)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,36)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,40)._focusChanged(false)) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,40)._focusChanged(true)) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,40)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.formula = $event)) !== false);
              ad = (pd_7 && ad);
            }
            if (('click' === en)) {
              const pd_8:any = ((<any>_co.setCaretPosition(i1.ɵnov(_v,34))) !== false);
              ad = (pd_8 && ad);
            }
            if (('keyup' === en)) {
              const pd_9:any = ((<any>_co.setCaretPosition(i1.ɵnov(_v,34))) !== false);
              ad = (pd_9 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(35,16384,(null as any),0,i3.MdPrefixRejector,
          [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(36,16384,(null as any),0,i5.DefaultValueAccessor,[i1.Renderer2,i1.ElementRef,
          [2,i5.COMPOSITION_BUFFER_MODE]],(null as any),(null as any)),i1.ɵprd(1024,
          (null as any),i5.NG_VALUE_ACCESSOR,(p0_0:any) => {
            return [p0_0];
          },[i5.DefaultValueAccessor]),i1.ɵdid(38,671744,(null as any),0,i5.NgModel,
          [[8,(null as any)],[8,(null as any)],[8,(null as any)],[2,i5.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i5.NgControl,(null as any),[i5.NgModel]),i1.ɵdid(40,933888,(null as any),
          0,i3.MdInput,[i1.ElementRef,i1.Renderer2,i4.Platform,[2,i5.NgControl],[2,
              i5.NgForm],[2,i5.FormGroupDirective],[2,i3.MD_ERROR_GLOBAL_OPTIONS]],
          (null as any),(null as any)),i1.ɵdid(41,16384,(null as any),0,i5.NgControlStatus,
          [i5.NgControl],(null as any),(null as any)),i1.ɵprd(2048,[[4,4]],i3.MdFormFieldControl,
          (null as any),[i3.MdInput]),(_l()(),i1.ɵted(-1,1,['\n    '])),(_l()(),i1.ɵeld(44,
          0,(null as any),6,3,'md-hint',[['align','end'],['class','currentPosition mat-hint']],
          [[2,'mat-right',(null as any)],[1,'id',0],[1,'align',0]],(null as any),(null as any),
          (null as any),(null as any))),i1.ɵdid(45,16384,(null as any),0,i3.MdPrefixRejector,
          [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(46,16384,[[7,4]],0,i3.MdHint,([] as any[]),{align:[0,'align']},(null as any)),
      (_l()(),i1.ɵted(47,(null as any),['',''])),(_l()(),i1.ɵted(-1,1,['\n\n  '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n\n  '])),(_l()(),i1.ɵeld(50,0,(null as any),
          (null as any),17,'md-input-container',[['class','mat-input-container mat-form-field']],
          [[2,'mat-input-invalid',(null as any)],[2,'mat-form-field-invalid',(null as any)],
              [2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],[2,
                  'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,52)._control.focus()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdFormField_0,i2.RenderType_MdFormField)),i1.ɵdid(51,16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(52,7389184,(null as any),6,i3.MdFormField,
          [i1.ElementRef,i1.ChangeDetectorRef,[2,i3.MD_PLACEHOLDER_GLOBAL_OPTIONS]],
          (null as any),(null as any)),i1.ɵqud(335544320,10,{_control:0}),i1.ɵqud(335544320,
          11,{_placeholderChild:0}),i1.ɵqud(603979776,12,{_errorChildren:1}),i1.ɵqud(603979776,
          13,{_hintChildren:1}),i1.ɵqud(603979776,14,{_prefixChildren:1}),i1.ɵqud(603979776,
          15,{_suffixChildren:1}),(_l()(),i1.ɵted(-1,1,['\n    '])),(_l()(),i1.ɵeld(60,
          0,(null as any),1,1,'label',([] as any[]),(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['Example Result'])),
      (_l()(),i1.ɵted(-1,1,['\n    '])),(_l()(),i1.ɵeld(63,0,(null as any),1,3,'input',
          [['class','mat-input-element'],['disabled',''],['mdInput','']],[[8,'value',
              0],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',0],
              [1,'aria-describedby',0],[1,'aria-invalid',0]],[[(null as any),'blur'],
              [(null as any),'focus'],[(null as any),'input']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('blur' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,65)._focusChanged(false)) !== false);
              ad = (pd_0 && ad);
            }
            if (('focus' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,65)._focusChanged(true)) !== false);
              ad = (pd_1 && ad);
            }
            if (('input' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,65)._onInput()) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(64,16384,(null as any),0,i3.MdPrefixRejector,
          [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(65,933888,(null as any),0,i3.MdInput,[i1.ElementRef,i1.Renderer2,i4.Platform,
          [8,(null as any)],[2,i5.NgForm],[2,i5.FormGroupDirective],[2,i3.MD_ERROR_GLOBAL_OPTIONS]],
          {disabled:[0,'disabled']},(null as any)),i1.ɵprd(2048,[[10,4]],i3.MdFormFieldControl,
          (null as any),[i3.MdInput]),(_l()(),i1.ɵted(-1,1,['\n  '])),(_l()(),i1.ɵted(-1,
          (null as any),['\n  '])),(_l()(),i1.ɵeld(69,0,(null as any),(null as any),
          21,'div',[['class','test-area']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CalculationEditorComponent_3)),
      i1.ɵdid(72,16384,(null as any),0,i9.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CalculationEditorComponent_4)),
      i1.ɵdid(75,16384,(null as any),0,i9.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CalculationEditorComponent_5)),
      i1.ɵdid(78,16384,(null as any),0,i9.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵeld(80,16777216,(null as any),(null as any),9,'div',[['class','btn-test'],
          ['mdTooltipPosition','above']],(null as any),[[(null as any),'longpress'],
          [(null as any),'touchend']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('longpress' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,82).show()) !== false);
          ad = (pd_0 && ad);
        }
        if (('touchend' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,82).hide(1500)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(81,16384,(null as any),0,i3.MdPrefixRejector,
          [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(82,147456,(null as any),0,i3.MdTooltip,[i7.Overlay,i1.ElementRef,i6.ScrollDispatcher,
          i1.ViewContainerRef,i1.NgZone,i1.Renderer2,i4.Platform,i3.MD_TOOLTIP_SCROLL_STRATEGY,
          [2,i8.Directionality]],{position:[0,'position'],message:[1,'message']},(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n      '])),(_l()(),i1.ɵeld(84,0,(null as any),
          (null as any),4,'button',[['class','testButton mat-raised-button'],['color',
              'accent'],['md-raised-button','']],[[8,'disabled',0]],[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i15.CalculationEditorComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.runCalculation()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(85,16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(86,180224,(null as any),0,i3.MdButton,
          [i1.Renderer2,i1.ElementRef,i4.Platform,i3.FocusOriginMonitor],{disabled:[0,
              'disabled'],color:[1,'color']},(null as any)),i1.ɵdid(87,16384,(null as any),
          0,i3.MdRaisedButtonCssMatStyler,([] as any[]),(null as any),(null as any)),
      (_l()(),i1.ɵted(-1,0,['\n        Test\n      '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n    '])),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵted(-1,
          (null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n\n\n\n\n']))],
      (_ck,_v) => {
        var _co:i15.CalculationEditorComponent = _v.component;
        _ck(_v,10,0);
        const currVal_1:any = _co.calculationFields;
        _ck(_v,16,0,currVal_1);
        const currVal_25:any = _co.formula;
        _ck(_v,38,0,currVal_25);
        _ck(_v,40,0);
        const currVal_29:any = 'end';
        _ck(_v,46,0,currVal_29);
        const currVal_48:any = '';
        _ck(_v,65,0,currVal_48);
        const currVal_49:any = (_co.status == _co.ECalculationStatus.WAITING);
        _ck(_v,72,0,currVal_49);
        const currVal_50:any = (_co.status == _co.ECalculationStatus.Failure);
        _ck(_v,75,0,currVal_50);
        const currVal_51:any = (_co.status == _co.ECalculationStatus.SUCCESS);
        _ck(_v,78,0,currVal_51);
        const currVal_52:any = 'above';
        const currVal_53:any = _co.textTooltipText;
        _ck(_v,82,0,currVal_52,currVal_53);
        const currVal_55:boolean = !_co.canCalculate();
        const currVal_56:any = 'accent';
        _ck(_v,86,0,currVal_55,currVal_56);
      },(_ck,_v) => {
        var _co:i15.CalculationEditorComponent = _v.component;
        const currVal_0:any = (i1.ɵnov(_v,5).disabled || (null as any));
        _ck(_v,3,0,currVal_0);
        const currVal_2:any = i1.ɵnov(_v,23)._control.errorState;
        const currVal_3:any = i1.ɵnov(_v,23)._control.errorState;
        const currVal_4:any = i1.ɵnov(_v,23)._control.focused;
        const currVal_5:any = i1.ɵnov(_v,23)._shouldForward('untouched');
        const currVal_6:any = i1.ɵnov(_v,23)._shouldForward('touched');
        const currVal_7:any = i1.ɵnov(_v,23)._shouldForward('pristine');
        const currVal_8:any = i1.ɵnov(_v,23)._shouldForward('dirty');
        const currVal_9:any = i1.ɵnov(_v,23)._shouldForward('valid');
        const currVal_10:any = i1.ɵnov(_v,23)._shouldForward('invalid');
        const currVal_11:any = i1.ɵnov(_v,23)._shouldForward('pending');
        _ck(_v,21,0,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,
            currVal_9,currVal_10,currVal_11);
        const currVal_12:any = i1.ɵnov(_v,40).id;
        const currVal_13:any = i1.ɵnov(_v,40).placeholder;
        const currVal_14:any = i1.ɵnov(_v,40).disabled;
        const currVal_15:any = i1.ɵnov(_v,40).required;
        const currVal_16:any = (i1.ɵnov(_v,40)._ariaDescribedby || (null as any));
        const currVal_17:any = i1.ɵnov(_v,40).errorState;
        const currVal_18:any = i1.ɵnov(_v,41).ngClassUntouched;
        const currVal_19:any = i1.ɵnov(_v,41).ngClassTouched;
        const currVal_20:any = i1.ɵnov(_v,41).ngClassPristine;
        const currVal_21:any = i1.ɵnov(_v,41).ngClassDirty;
        const currVal_22:any = i1.ɵnov(_v,41).ngClassValid;
        const currVal_23:any = i1.ɵnov(_v,41).ngClassInvalid;
        const currVal_24:any = i1.ɵnov(_v,41).ngClassPending;
        _ck(_v,34,1,[currVal_12,currVal_13,currVal_14,currVal_15,currVal_16,currVal_17,
            currVal_18,currVal_19,currVal_20,currVal_21,currVal_22,currVal_23,currVal_24]);
        const currVal_26:any = (i1.ɵnov(_v,46).align == 'end');
        const currVal_27:any = i1.ɵnov(_v,46).id;
        const currVal_28:any = (null as any);
        _ck(_v,44,0,currVal_26,currVal_27,currVal_28);
        const currVal_30:any = _co.caretPos;
        _ck(_v,47,0,currVal_30);
        const currVal_31:any = i1.ɵnov(_v,52)._control.errorState;
        const currVal_32:any = i1.ɵnov(_v,52)._control.errorState;
        const currVal_33:any = i1.ɵnov(_v,52)._control.focused;
        const currVal_34:any = i1.ɵnov(_v,52)._shouldForward('untouched');
        const currVal_35:any = i1.ɵnov(_v,52)._shouldForward('touched');
        const currVal_36:any = i1.ɵnov(_v,52)._shouldForward('pristine');
        const currVal_37:any = i1.ɵnov(_v,52)._shouldForward('dirty');
        const currVal_38:any = i1.ɵnov(_v,52)._shouldForward('valid');
        const currVal_39:any = i1.ɵnov(_v,52)._shouldForward('invalid');
        const currVal_40:any = i1.ɵnov(_v,52)._shouldForward('pending');
        _ck(_v,50,0,currVal_31,currVal_32,currVal_33,currVal_34,currVal_35,currVal_36,
            currVal_37,currVal_38,currVal_39,currVal_40);
        const currVal_41:any = _co.result;
        const currVal_42:any = i1.ɵnov(_v,65).id;
        const currVal_43:any = i1.ɵnov(_v,65).placeholder;
        const currVal_44:any = i1.ɵnov(_v,65).disabled;
        const currVal_45:any = i1.ɵnov(_v,65).required;
        const currVal_46:any = (i1.ɵnov(_v,65)._ariaDescribedby || (null as any));
        const currVal_47:any = i1.ɵnov(_v,65).errorState;
        _ck(_v,63,0,currVal_41,currVal_42,currVal_43,currVal_44,currVal_45,currVal_46,
            currVal_47);
        const currVal_54:any = (i1.ɵnov(_v,86).disabled || (null as any));
        _ck(_v,84,0,currVal_54);
      });
}
export function View_CalculationEditorComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-calculation-editor',
      ([] as any[]),(null as any),(null as any),(null as any),View_CalculationEditorComponent_0,
      RenderType_CalculationEditorComponent)),i1.ɵdid(1,114688,(null as any),0,i15.CalculationEditorComponent,
      [i16.CalculationService,i3.MdDialog,i17.FieldGroupService],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,1,0);
      },(null as any));
}
export const CalculationEditorComponentNgFactory:i1.ComponentFactory<i15.CalculationEditorComponent> = i1.ɵccf('app-calculation-editor',
    i15.CalculationEditorComponent,View_CalculationEditorComponent_Host_0,{fieldGroupId:'fieldGroupId',
        field:'field'},{onCalculationStatusChanged:'onCalculationStatusChanged'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/form-builder/components/calculation-editor/calculation-editor.component.ngfactory.ts